import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.assign.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    shuffle: Boolean,
    unit: String,
    digit: Number,
    time: {
      // 是否是时间模式
      type: Boolean,
      default: true
    },
    mode: {
      // 翻页模式 递增add/递减reduce/跳跃jump
      type: String,
      default: 'reduce'
    },
    previousDigitProps: {
      // 用于自定义下页上页数字/ mode为jump时候生效
      type: Number,
      default: null
    }
  },
  data: function data() {
    return {};
  },
  computed: {
    // 分离静态数据计算，减少不必要的重新计算
    digitData: function digitData() {
      // 计算当前数字 - add zero
      var currentDigit = this.digit;
      if (currentDigit < 10 && this.time) {
        currentDigit = "0".concat(currentDigit);
      }

      // 计算前一个数字 - to prevent a negative value
      var previousDigit;
      if (this.mode === 'add') {
        // 递增模式
        previousDigit = this.digit - 1;
      } else if (this.mode === 'reduce') {
        // 递减模式
        previousDigit = this.digit + 1;
      } else if (this.mode === 'jump') {
        // 自定义previousDigit
        previousDigit = this.previousDigitProps;
      }
      if (this.unit === 'minutes' || this.unit === 'seconds') {
        // minutes and seconds
        previousDigit = previousDigit === 60 ? 0 : previousDigit;
      } else if (this.unit === 'hours') {
        // hour
        previousDigit = previousDigit === 24 ? 0 : previousDigit;
      }

      // add zero
      if (previousDigit < 10 && this.time) {
        previousDigit = "0".concat(previousDigit);
      }
      return {
        currentDigit: currentDigit,
        previousDigit: previousDigit
      };
    },
    // 动画相关的计算属性，只在shuffle变化时重新计算
    animationData: function animationData() {
      var _this$digitData, _this$digitData2, _this$digitData3, _this$digitData4;
      return {
        digit1: this.shuffle ? (_this$digitData = this.digitData) === null || _this$digitData === void 0 ? void 0 : _this$digitData.previousDigit : (_this$digitData2 = this.digitData) === null || _this$digitData2 === void 0 ? void 0 : _this$digitData2.currentDigit,
        digit2: !this.shuffle ? (_this$digitData3 = this.digitData) === null || _this$digitData3 === void 0 ? void 0 : _this$digitData3.previousDigit : (_this$digitData4 = this.digitData) === null || _this$digitData4 === void 0 ? void 0 : _this$digitData4.currentDigit,
        animation1: this.shuffle ? 'fold' : 'unfold',
        animation2: !this.shuffle ? 'fold' : 'unfold'
      };
    },
    // 合并所有数据
    flipData: function flipData() {
      return Object.assign({}, this.digitData, this.animationData);
    }
  },
  watch: {},
  methods: {},
  /**
   * 组件挂载后初始化
   */
  mounted: function mounted() {},
  /**
   * 组件销毁前清理资源
   */
  beforeDestroy: function beforeDestroy() {}
};